import React, { useState } from 'react'
import { LOGO_IMG } from '../../../utills/image-constant'
import Inputwithlable from '../../components/common/inputwithlable'
import { useDispatch, useSelector } from 'react-redux';
import { checkValidation, ErrorMessage, ErrorMsg } from '../../../utills/error-message-constant';
import { passwordRegex } from '../../../utills/form-regex';
import { toastEmitter } from '../../../utills/utilities';
import { handleFormInput } from '../../../utills/formutilities';
import { changePasswordAdmin } from '../../../services/api-services';
import { API_RESPONSE } from '../../../utills/app-constant';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes/url-constant';
import { clearLoggedUserReducer, setLoggedUserReducer } from '../../hooks/redux/slice/logged-user';
import { clearAccessTokenReducer, setAccessTokenReducer } from '../../hooks/redux/slice/access-token';

const FirstTimeChangePass = () => {
    const { value } = useSelector((state) => state?.loggedUser);
    const [formError, setFormError] = useState();
    const [payload, setpayload] = useState({
        id: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    })
    const dispatch = useDispatch();
    const navigation = useNavigate();
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "oldPassword") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.Password,
                passwordRegex,
                formError,
                setFormError
            );
        }
        if (name === "newPassword") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.Password,
                passwordRegex,
                formError,
                setFormError
            );
        }
        if (name === "confirmPassword") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.ConfirmPassword,
                passwordRegex,
                formError,
                setFormError
            );
        }
        setpayload(handleFormInput(e, payload))
    }

    const handleChangePassword = async () => {
        if (payload?.newPassword !== payload?.confirmPassword) {
            toastEmitter("error", "New Password And Confirm Password Should be Same");
            return;
        }
        let changePasswordPayload = {
            id: value?.id,
            oldPassword: payload?.oldPassword,
            newPassword: payload?.newPassword
        }
        try {
            const response = await changePasswordAdmin(changePasswordPayload);
            if (response?.data?.responseCode !== 200) {
                toastEmitter("error", response?.data?.message);
            }

            if (response.data?.responseCode === 200) {
                toastEmitter("success", response?.data?.message);
                localStorage.clear();
                dispatch(clearAccessTokenReducer());
                dispatch(clearLoggedUserReducer());
                navigation(ROUTES.ADMINLOGINPAGE)

            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    }

    return (
        <div className="caspera_login_account_content d-flex justify-content-center align-items-center">
            <div class="card forget-div rounded-4 shadow-sm p-5 pt-4 pb-4 border-0">
                <div class="card-body">
                    <div className='d-flex justify-content-center align-items-center'>
                        <img src={LOGO_IMG} class="img-fluid mb-4 logo_img" alt="..." />
                    </div>
                    <p className='card-text text-center mb-1 textfont12'>WELCOME BACK</p>
                    <h5 class="card-text text-center">Log In to Your Account</h5>

                    <div className="row ">
                        <div className="col-md-12">
                            <Inputwithlable
                                placeHolder="Enter the current password"
                                name="oldPassword"
                                type="text"
                                labelName="Current Password"
                                lableclassName="input-label"
                                className="form-control inputText-lable"
                                value={payload?.oldPassword}
                                handleChange={handleChange}
                                error={formError?.passwordStatus}
                            />
                        </div>
                        <div className="mt-2 ms-2"><ErrorMsg error={formError?.oldPassword} /></div>
                        <div className="col-md-12">
                            <Inputwithlable
                                placeHolder="Enter the new password"
                                name="newPassword"
                                type="text"
                                labelName="New Password"
                                lableclassName="input-label"
                                className="form-control inputText-lable"
                                value={payload?.newPassword}
                                handleChange={handleChange}
                            />
                        </div>
                        <div className="mt-2 ms-2"><ErrorMsg error={formError?.newPassword} /></div>
                        <div className="col-md-12">
                            <Inputwithlable
                                placeHolder="Enter the confirm password"
                                name="confirmPassword"
                                type="text"
                                labelName="Confirm New Password"
                                lableclassName="input-label"
                                className="form-control inputText-lable"
                                value={payload?.confirmPassword}
                                handleChange={handleChange}
                                error={formError?.confirmPasswordStatus}
                            />
                        </div>
                        <div className="mt-2 ms-2"><ErrorMsg error={formError?.confirmPassword} /></div>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                        <button className="changespassword mt-4 mb-0" onClick={handleChangePassword}>Change Password</button>
                    </div>

                </div>
            </div>


        </div>
    )
}

export default FirstTimeChangePass
